import { Box, Container } from "@mui/material";
import '@mdxeditor/editor/style.css'
import { BlockTypeSelect, BoldItalicUnderlineToggles, CreateLink, InsertImage, ListsToggle, MDXEditor, Separator, UndoRedo, headingsPlugin, imagePlugin, linkDialogPlugin, linkPlugin, listsPlugin, quotePlugin, thematicBreakPlugin, toolbarPlugin } from '@mdxeditor/editor'
import { ArticleEditor } from "./ArticleEditor";

export const CreateArticle = () => {
    return (
        <Container disableGutters>
            <ArticleEditor article={undefined} />
        </Container>
    );
};